'use strict';

angular.module('cfn').directive('dAutocomplete', [
  '$timeout',
  '$q',
  function($timeout, $q) {
    return {
      restrict: 'E',
      scope: {
        asyncsearchservicefn: '&',
        onitemselected: '&',
        maxItems: '@',
        minCharCount: '@',
        typingDebounceTime: '@',
        placeholder: '@',
        clearOnSelection: '@',
        deletableInputText: '=?',
        cssTestClass: '@',
        selectedYear: '@',
        mandatory: '@'

      },
      template: function compile(element, attrs) {
        var tplVar = {
          autocompleteItemTpl:
            element.html() !== '' ? element.html() : '{{item}}', // description see below.
          HTML5placeholder:
            attrs.placeholder !== undefined
              ? attrs.placeholder.replaceAll("'", '"')
              : '',
          cssTestClass: attrs.cssTestClass
        };

        return (
          "<div class='inner'>" +
          "<input  type      = 'text' " +
          "class='" + tplVar.cssTestClass + "'" +
          "ng-model  = 'autocomplete.inputText' " +
          "ng-model-options='{debounce: typingDebounceTime || 0}'" +
          "ng-change    = 'autocomplete.onInputChange()' " +
          "ng-click     = 'autocomplete.onInputClick($event)' " +
          "ng-focus     = 'autocomplete.onInputFocus()' " +
          "ng-blur      = 'autocomplete.onInputBlur()' " +
          "ng-required  = '" + attrs.mandatory + "'" +
          "autocomplete ='off'" +
          "placeholder  ='" +
          tplVar.HTML5placeholder +
          "' />" +
          "<div ng-if='" + attrs.mandatory + " && autocomplete.inputText.length === 0' class='bl-sowing-culture-required-message'>{{'fe.fertilizer.calculator.planning.nutrient.requirement.parameter.required' | i18n}}</div>" +
          "<i class='delete-input-text-icon' ng-if='autocomplete.showInputTextDeleteIcon && deletableInputText' ng-click='autocomplete.deleteInputText()'></i>" +
          "<ul ng-show = 'autocomplete.isAutolistShown'>" +
          "<li ng-repeat      = 'item in autocomplete.autocompleteItems track by item.id' " +
          "class          = 'line-item " + tplVar.cssTestClass + "-item-{{$index}}'" +
          "ng-mouseenter  = 'autocomplete.onMouseEnter(item)'" +
          "ng-mousedown   = 'autocomplete.onItemClick(item)'" +
          '>' +
          "<div class='inner'>" +
          tplVar.autocompleteItemTpl + // This is the line-item that shows an autocomplete option.
          // It can be configured directly when using the directive in
          // a template.
          // eg. : <d-autocomplete "...">Name: {{item.someName}}</d-autocomplete>
          '</div>' +
          '</li>' +
          "<li ng-show='autocomplete.hasNotFoundAnything' class='line-item-notfound italictext'><div class='inner'>{{'fe.common.noItemsFound'|i18n:'Keine Einträge gefunden' :  autocomplete.getInputTextWithQuotes()}}</div></li>" +
          "<li ng-show='autocomplete.hasMoreElements' class='last-line italictext'><div class='inner'>{{'fe.autocomplete.results.summary'|i18n:'{0} von {1} Ergebnissen – vervollständigen Sie Ihre Eingabe für genauere Ergebnisse' : autocomplete.autocompleteItems.length : autocomplete.foundCount}}</div></li>" +
          "<li ng-show='autocomplete.isLoading && !autocomplete.hasNotFoundAnything' class='line-item-loading'><div class='inner text-center'><img src='img/ajax-loader-circle.gif'/></div></li>" +
          '</ul>' +
          '</div>'
        );
      },
      link: function(scope, elem) {
        var isInputFocused = false, // isInputFocused is needed as support for the functionality of selecting the complete text when user clicks into input field.
          // (if there already is any text)
          maxAutocompleteItems = scope.maxItems || 10,
          enableMore = scope.enableMore,
          minCharCount = scope.minCharCount || 0, //minimal number of characters from which the results will be searched for.
          typingDebounceTime = scope.typingDebounceTime || 0,
          $inputField = elem.find('.inner > input'),
          clearOnSelection = scope.clearOnSelection === 'true',
          mandatoryOriginal = scope.mandatory ? scope.mandatory : false,
          autocomplete = (scope.autocomplete = {
            autocompleteItems: [],
            foundCount: 0,
            inputText: '',
            isLoading: false,
            isAutolistShown: false,
            hasNotFoundAnything: false,
            hasMoreElements: false,
            showInputTextDeleteIcon: false,
            selectedItem: null,
            onInputChange: function() {
              asyncSearchServiceUpdate();
              toggleShow('SHOW');
            },
            onInputClick: function($event) {
              selectFullInputText($event.target);
              isInputFocused = true;
            },
            onInputFocus: function() {
              asyncSearchServiceUpdate();
              toggleShow('SHOW');
            },
            onInputBlur: function() {
              isInputFocused = false;
              toggleShow('HIDE');
            },
            getInputTextWithQuotes: function() {
              return '"' + autocomplete.inputText + '"';
            },
            onItemClick: selectItem,
            //other services/tools (or ugly globals) to be used in the templates
            enums: enums,
            deleteInputText: function() {
              autocomplete.inputText = '';
            }
          });

        function asyncSearchServiceUpdate() {
          if (!autocomplete.inputText) { autocomplete.inputText = ''; };
          if (autocomplete.inputText && autocomplete.inputText.length < minCharCount) {
            return;
          }

          autocomplete.isLoading = true;

          scope.asyncsearchservicefn({ item: autocomplete.inputText })
            .then(function(data) {
              if (data.searchString === autocomplete.inputText) {
                setAutocompleteItems(data.results);
                // directive is use for generic search service and also seedSearchService
                // to get total elements from seedSearchService doubleckeck data request result
                if(typeof data.totalElements !== 'undefined'){
                  autocomplete.hasMoreElements = !data.last;
                  autocomplete.foundCount = data.totalElements;
                }
                autocomplete.isLoading = false;
              }
            })
            .catch(function() {
              autocomplete.isLoading = false;
            }
           );
        }

        function setAutocompleteItems(data) {
          autocomplete.hasNotFoundAnything = data.length === 0;
          //warning isNaN('x') == true but _.isNaN('x') == false
          //we want here to  have a valid number
          autocomplete.foundCount = data.length;
          if (maxAutocompleteItems && !isNaN(maxAutocompleteItems)) {
            autocomplete.hasMoreElements = data.length > maxAutocompleteItems;
            autocomplete.autocompleteItems = data.slice(
              0,
              maxAutocompleteItems
            );

            autocomplete.isLoading = false;

            // trigger scope digest manually
            scope.$digest();
          } else {
            //show all
            autocomplete.autocompleteItems = data;
            autocomplete.hasMoreElements = false;
          }
        }

        function clearAutocompleteItems() {
          autocomplete.autocompleteItems = [];
        }

        function selectItem(thisItem) {
          if ($inputField.is(':focus')) $inputField.blur(); // IE Hack. IE does not blur inputField when item is selected.
          scope.onitemselected({ selectedItem: thisItem });
          if (clearOnSelection) {
            autocomplete.inputText = '';
          }
          toggleShow('HIDE');
        }

        function selectFullInputText(elem) {
          if (!isInputFocused) elem.select();
        }

        function toggleDeleteIcon() {
          if (!scope.deletableInputText) {
            return;
          }
          autocomplete.showInputTextDeleteIcon = !!autocomplete.inputText;
        }

        function toggleShow(mode) {
          switch (mode) {
            case 'SHOW':
              autocomplete.isAutolistShown = true;
              break;
            case 'HIDE':
              clearAutocompleteItems();
              autocomplete.isAutolistShown = false;
              break;
          }
        }

        if (scope.deletableInputText) {
          scope.$watch('autocomplete.inputText', toggleDeleteIcon);
        }
      }
    };
  }
]);
